import { UseQueryResult, useQuery } from '@tanstack/react-query';
import {
    Etablissement,
    PayBudget,
} from 'routes/HumanResourcesModule/PayState/helpers/types';
import { RQAPICall } from 'store/APIClient';

export const useGetPayBudget = (): UseQueryResult<PayBudget[]> => {
    const endpoint = 'human_resources/pay_budget';
    return useQuery({
        queryKey: ['all_pay_budget'],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
                method: 'GET',
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};
export const useGetEtablissements = (): UseQueryResult<Etablissement[]> => {
    const endpoint = 'human_resources/etablissement';

    return useQuery({
        queryKey: ['all_etablissements'],
        queryFn: async () => {
            const getResponse = await RQAPICall({
                endpoint,
                method: 'GET',
            });
            return getResponse.content.data;
        },
        meta: {
            useGlobalOnError: true,
        },
    });
};
